import { memo, useCallback } from 'react';
import { UserDropdown } from './UserDropdown';
import { GlobalSearch } from '@/components/ui/global-search';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import { useSidebar } from '@/contexts/SidebarContext';
import { SubscriptionExpiryBadge } from '@/components/subscription/SubscriptionExpiryBadge';
import { Menu } from 'lucide-react';

// Memoized Header to prevent unnecessary re-renders
export const Header = memo(() => {
  const { toggleSidebar, isCollapsed } = useSidebar();
  
  // Memoize toggle handler
  const handleToggle = useCallback(() => {
    toggleSidebar();
  }, [toggleSidebar]);
  
  return <header className={`fixed top-0 right-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border/40 transition-all duration-300 left-0 ${isCollapsed ? 'lg:left-14' : 'lg:left-64'}`}>
      <div className="flex items-center h-16 px-3 sm:px-4 lg:px-8 gap-2 sm:gap-4 bg-primary">
        {/* Botão de menu mobile - alinhado com altura dos outros elementos */}
        <button 
          onClick={handleToggle}
          className="lg:hidden p-2 h-10 w-10 flex items-center justify-center hover:bg-primary-foreground/10 rounded-lg transition-colors shrink-0"
          aria-label={isCollapsed ? 'Abrir menu de navegação' : 'Fechar menu de navegação'}
          aria-expanded={!isCollapsed}
        >
          <Menu className="h-5 w-5 text-primary-foreground" aria-hidden="true" />
        </button>
        
        {/* Barra de busca - alinhada à esquerda próxima da sidebar */}
        <div className="flex-1 min-w-0">
          <div className="w-full max-w-md">
            <ErrorBoundary fallback={<div className="relative w-full">
                <input placeholder="Buscar em tudo..." className="pl-10 w-full bg-background border-border text-body sm:text-body rounded-md border px-3 py-2" disabled />
              </div>}>
              <GlobalSearch />
            </ErrorBoundary>
          </div>
        </div>
        
        {/* Badge de expiração da assinatura */}
        <div className="shrink-0">
          <SubscriptionExpiryBadge />
        </div>
        
        {/* Dropdown do usuário */}
        <div className="shrink-0">
          <UserDropdown />
        </div>
      </div>
    </header>;
});